import type React from 'react';

import { InfoCircleFilledIcon } from '@vlabs/icons';
import { Info } from '@vlabs/monokit/shared/ui/info';
import { Trans } from 'react-i18next';

import { useUserDetailsPageTranslation, ns } from '../i18n';
import st from './UserDetailsInfo.module.sass';

export function UserDetailsInfo(): React.JSX.Element {
  const { t } = useUserDetailsPageTranslation();
  return (
    <div className={st.Container}>
      <Info
        icon={<InfoCircleFilledIcon className={st.InfoIcon} />}
        title={t('info.title')}
      >
        <div className={st.Description}>
          <Trans
            components={{ span: <span /> }}
            i18nKey="info.content"
            ns={ns}
          />
        </div>
      </Info>
    </div>
  );
}
